<template>
  <!--  只允许一个 组件 -->
  <a-layout class="container center-container ">

    <!-- 中间布局 -->
    <a-layout-content class="center-div">

      <!-- 上部 3 列 -->
      <a-row class="gutter-row-1">
        <a-col :span="6">
          <div class="gutter-box1">
            <!-- 推荐消息 -->
            <a-card :hoverable="false" :bordered="true" style="padding: 0px;margin:0px 10px;height: 300px;cursor:auto;"
              :bodyStyle="{ padding: '5px' }" :type="'inner'" class="card">
              <a-list :data-source="recommendArticles">
                <template #renderItem="{ item }">
                  <a-list-item>
                    <a :href="'/#/doc?articleId=' + item.articleVO.id" target="_blank">
                      <span class="display-line1">
                        <!-- 阿里巴巴图标库字体 -->
                        <icon-font type="icon-tuijian" style="font-size: 16px;"></icon-font>
                        <!-- 序号 -->
                        <!-- <span style="color: gray;font-style: italic;">{{ (index + 1) + '. ' }} </span> -->
                        <!-- 标题 -->
                        {{ item.articleVO.title }}
                        <!-- 描述 -->
                        <span style="font-size: 14px;color: gray;">({{ item.articleVO.description }})</span>
                      </span>
                    </a>
                  </a-list-item>
                </template>
              </a-list>

            </a-card>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="gutter-box2">
            <!-- 走马灯图片 -->
            <!-- :after-change="onChange" -->
            <a-carousel autoplay>
              <!-- 背景图片：<div style="width: 100%;height: 300px;background: url('/image/banner/01.jpg');"></div> -->
              <div v-for="item in banners" v-bind:key="item.id">
                <a :href="item.link" target="_blank">
                  <a-image :height="300" :preview="false" :src="item.bannerUrl" />
                </a>
              </div>
            </a-carousel>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="gutter-box3">
            <!-- 自我介绍 -->
            <a-card :hoverable="false" :bordered="true"
              style="height:300px;padding: 10px;margin:0px 10px;text-align: center;cursor:auto;"
              :bodyStyle="{ padding: '5px' }" :type="'inner'" class="card">
              <a-row>
                <a-col :span="24">
                  <a-avatar :size="100" :src="require('@/assets/user.jpg')">
                  </a-avatar>
                </a-col>
                <a-col :span="24">
                  <h3 style="margin-top: 5px;">佰特编码CTO</h3>
                  <div style="text-align: left;color: #606266;">
                    物联网科技公司创始人、互联网资深技术专家、分布式与微服务架构专家。一直致力于分布式系统架构、微服务、云计算与物联网技术的研究。
                    在智慧城市、智慧医疗、智慧物流、智慧停车等领域拥有丰富的项目与架构经验。
                  </div>
                  <!-- 微信&email -->
                  <div style="margin-top: 5px;">
                    <a-popover title="微信二维码">
                      <template #content>
                        <!-- 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png' -->
                        <a-image :width="200" :preview="false" :src="require('@/assets/wechat.jpg')" />
                      </template>
                      <WechatOutlined :style="{ fontSize: '18px', color: '#303133' }" />
                    </a-popover>
                    &nbsp; &nbsp;
                    <a-popover title="电子邮箱">
                      <template #content>
                        <p class="font-primary">yinjisheng@126.com</p>
                      </template>
                      <MailOutlined :style="{ fontSize: '18px', color: '#303133' }" />
                    </a-popover>
                  </div>
                </a-col>
              </a-row>
            </a-card>
          </div>
        </a-col>
      </a-row>

      <!-- 下部 3 列 -->
      <!-- 左侧菜单 '64px' -->
      <a-row class="gutter-row-2">
        <a-col :span="3">
          <div class="gutter-box4">
            <!-- 垂直一级菜单 -->
            <a-card :hoverable="false" :bordered="true"
              style="width: 160px;margin-left: 20px;padding: 0px;cursor:pointer;" :bodyStyle="{ padding: '5px' }"
              :type="'inner'" class="card">
              <a-menu v-model:openKeys="openKeys1" v-model:selectedKeys="selectedKeys1"
                style="width: 100%;border: none;text-align: center;" mode="vertical" :items="items1"
                @click="handleClick1" />
            </a-card>
          </div>
        </a-col>
        <a-col :span="15">
          <div class="gutter-box5">
            <!-- 中间数据 -->
            <a-card :hoverable="false" :bordered="true" style="padding: 0px;margin:0px 10px;cursor:auto;"
              :bodyStyle="{ padding: '5px' }" :type="'inner'" class="card">
              <!-- 二级标题 -->
              <a-tabs v-model:activeKey="activeTabKey2" @tabClick="handleTabClick2" style="margin: 0px 20px;">
                <!-- <a-tab-pane key="2" tab="CSS" force-render></a-tab-pane> -->
                <a-tab-pane v-for="tab of items2" :key="tab.key" :tab="tab.name"></a-tab-pane>
              </a-tabs>

              <!-- 文章列表 -->
              <a-list item-layout="vertical" :data-source="articleData">
                <template #renderItem="{ item }">
                  <!-- 样式 1 -->
                  <!-- <list-item1 v-if="item.type == 1" :data="{ item }"></list-item1> -->
                  <!-- 样式2 -->
                  <!-- <list-item2 v-if="item.type == 2" :data="{ item }"></list-item2> -->
                  <!-- 样式3 -->
                  <!-- <list-item3 v-if="item.type == 3" :data="{ item }"></list-item3> -->
                  <a-list-item>
                    <a-list-item-meta>
                      <template #title>
                        <a :href="'/#/doc?articleId=' + item.id" target="_blank">{{ item.title }}</a>
                      </template>
                      <template #description>
                        <span> {{ item.description }}</span>
                      </template>
                      <template #avatar v-if="item.coverUrl != undefined && item.coverPos == 'left'">
                        <!-- 左侧图片 -->
                        <a-image :width="96" alt="图片" :src="item.coverUrl" />
                      </template>
                    </a-list-item-meta>
                    <template #extra v-if="item.coverUrl != undefined && item.coverPos == 'right'">
                      <!-- 右侧图片 -->
                      <!-- <img width="96" height="96" alt="logo" :src="item.coverUrl" /> -->
                      <a-image :height="96" alt="图片" :src="item.coverUrl" />
                    </template>
                    <template #actions>
                      <!-- 阅读数 -->
                      <span>
                        <component v-bind:is="'UserOutlined'" style="margin-right: 8px" />
                        {{ item.viewCount }}
                      </span>
                      <!-- 点赞数 -->
                      <span>
                        <component v-bind:is="'LikeOutlined'" style="margin-right: 8px" />
                        {{ item.voteCount }}
                      </span>
                    </template>
                    <!-- 内容摘要 -->
                    {{ item.summary }}
                  </a-list-item>
                </template>
              </a-list>

              <!-- 分页 -->
              <div style="margin: 10px;float: right">
                <a-pagination v-model:current="currentPage" v-model:pageSize="currentSize" :total="total"
                  @change="onPageChange" @showSizeChange="onShowSizeChange" />
              </div>
            </a-card>

          </div>
        </a-col>
        <a-col :span="6">
          <div class="gutter-box6">
            <!-- 右侧top10 -->
            <a-card :hoverable="false" :bordered="true" style="padding: 0px;margin:0px 10px;cursor:auto;"
              :bodyStyle="{ padding: '5px' }" :type="'inner'" title="热门文章 Top10" class="card">
              <a-list :bordered="false" :data-source="hotArticles" style="margin:0px;">
                <template #renderItem="{ item, index }">
                  <a-list-item>
                    <a :href="'/#/doc?articleId=' + item.id" target="_blank">
                      <span class="display-line1">
                        <!-- 序号 -->
                        <span style="color: gray;font-style: italic;">{{ (index + 1) + '. ' }} </span>
                        <!-- 标题 -->
                        {{ item.title }}
                        <!-- 描述 -->
                        <span style="font-size: 14px;color: gray;">({{ item.description }})</span>
                      </span>
                    </a>
                  </a-list-item>
                </template>
              </a-list>

            </a-card>

          </div>
        </a-col>
      </a-row>


    </a-layout-content>

    <!-- 返回页面顶部的操作按钮。 -->
    <a-back-top type="default" />

    <!-- 页脚 -->
    <div style="margin-top: 50px;width: 100%;">
      <the-footer></the-footer>
    </div>

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, reactive, toRef } from 'vue';
// 引入axios 库
import axios from "axios";
import { message } from "ant-design-vue";
import type { MenuProps } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
import useRouter from '@/router'
import TheFooter from "@/components/the-footer.vue";
// import ListItem1 from '@/components/list-item1.vue';
// import ListItem2 from '@/components/list-item2.vue';
// import ListItem3 from '@/components/list-item3.vue';



export default defineComponent({
  name: 'HomeView',
  components: {
    TheFooter,

    // ListItem1,
    // ListItem2,
    // ListItem3,
  },
  setup() {
    console.log('setup ...')

    // 获取url参数 http://localhost:9999/?categoryId=101
    const route = useRoute();

    // 推荐文章 6
    const recommendArticles: any = ref([])
    // 轮播图
    const banners: any = ref([])
    // 热门文章Top 10
    const hotArticles: any = ref([])

    // 分类 1
    const level1 = ref();
    let categorys: any;

    // 1 级菜单
    const selectedKeys1: any = ref([]); //'1'
    const openKeys1: any = ref([]);
    const items1: any = ref([]);

    // 2 级菜单
    const items2: any = ref([]);
    // 激活的菜单
    const activeTabKey2: any = ref(''); //'1'

    // 列表文章
    const articleData = ref([]);

    // 当前页码
    const currentPage = ref(1);
    const currentSize = ref(10);
    const total = ref(0);


    /**
     * 查询所有分类
     **/
    const queryCategory = () => {

      axios.get("/app/category/all").then((response) => {
        const result = response.data;
        //console.log('categorys', result)
        if (result.code == 0 && result.message == 'success') {
          // 处理 level
          categorys = result.data.list;
          console.log("原始数组：", categorys);

          level1.value = [];
          level1.value = Tool.array2Tree(categorys, 0);
          console.log("树形结构：", level1.value);

          /**
           * 封装 1 级菜单item
           *  {
           *    key: '1',
           *    label: '前端开发',
           *    title: '前端开发',
           *  },
           */
          let index = 0
          for (let cat of level1.value) {
            index++
            //console.log('cat', index, cat)
            items1.value.push({
              key: cat.id.toString(),
              label: cat.name,
              title: cat.name,
            })
            // 选中的item默认第一个数据
            if (index == 1) {
              // 选中 1 级菜单
              selectedKeys1.value.push(cat.id.toString())
              // 渲染 2 级菜单
              selectedItems2(cat)
            }
          }
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 选中二级菜单 Tab卡页 & 拉取文章数据
     * @param cat1 一级菜单
     */
    const selectedItems2 = (cat1: any) => {
      // 先清空 2 级菜单
      items2.value = []
      activeTabKey2.value = undefined
      // 没有二级菜单
      if (cat1.children == undefined || cat1.children.length == 0) {
        // 清空掉文章列表
        articleData.value = []
        total.value = 0
        currentPage.value = 0
        return
      }
      // 取出 2 级菜单
      let subIndex = 0
      for (let subCat of cat1.children) {
        subIndex++
        //console.log('subCat', subIndex, subCat)
        items2.value.push({
          key: subCat.id.toString(),
          name: subCat.name,
        })
        // 默认选中第一个卡页
        if (subIndex == 1) {
          activeTabKey2.value = subCat.id.toString()
          // 拉取文章列表
          queryArticlesList({})

        }
      }
      console.log('items2', items2.value)
      console.log('activeTabKey2', activeTabKey2.value)
    }

    /**
     * 查询推荐文章
     **/
    const queryRecommendArticle = () => {

      axios.get("/app/recommend/articles").then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          // 处理 level
          recommendArticles.value = result.data.list;
          console.log("推荐文章: ", recommendArticles.value);
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 查询轮播图
     **/
    const queryRecommendBanners = () => {

      axios.get("/app/recommend/banners").then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          // 处理 level
          banners.value = result.data.list;
          console.log("推荐轮播图: ", banners.value);
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 查询热门文章 Top10
     **/
    const queryHotArticle = () => {

      axios.get("/app/hot/articles/10").then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          hotArticles.value = result.data;
          console.log("热门文章Top10: ", hotArticles.value);
        } else {
          message.error(result.message);
        }
      });
    };


    /**
     * 拉取文章列表
     */
    const queryArticlesList = (param: any) => {

      // 请求参数
      param = {
        page: currentPage.value,
        size: currentSize.value,
        categoryId1: parseInt(selectedKeys1.value[0]),
        categoryId2: parseInt(activeTabKey2.value)
      }
      console.log('param', param)
      articleData.value = []

      axios.post("/app/article/list", param).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          articleData.value = result.data.list;
          total.value = result.data.total
          console.log("文章列表: ", articleData.value);
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 分页点击事件
     */
    const onPageChange = (page: any) => {
      // 点击的页码
      console.log("page: ", page); // page:  5
      // 修改当前页面
      currentPage.value = page
      console.log("currentPage: " + currentPage.value + ", currentSize:" + currentSize.value); // page:  5
      // 拉取文章列表
      queryArticlesList({})
    };

    /**
     * 选择页码的数量改变
     */
    const onShowSizeChange = (current: number, pageSize: number) => {
      // 点击的页码
      console.log("page: " + current + ", size: " + pageSize);
      currentSize.value = pageSize
    }

    // ---------------- 监控值 ----------------
    watch(currentSize, () => {
      console.log('---------currentSize---------', currentSize.value);
    });
    watch(currentPage, () => {
      console.log('---------currentPage---------', currentPage.value);
    });


    /**
     *  1 级菜单点击事件
     */
    const handleClick1: MenuProps['onClick'] = menuInfo => {
      console.log('click1 ', menuInfo);
      console.log('key1 ', menuInfo.key);
      // 刷新一下 key1
      selectedKeys1.value[0] = menuInfo.key
      // 过滤 1 级菜单 
      for (let cat1 of level1.value) {
        //console.log('cat1 ', cat1);
        if (cat1.id == menuInfo.key) {
          // 渲染 2 级菜单,并拉取文章列表
          selectedItems2(cat1)
        }
      }

    };

    /**
     * 2 级菜单卡页点击事件
     */
    const handleTabClick2 = (key: any) => {
      // 2级菜单key
      console.log(key)
      activeTabKey2.value = key
      // 1级菜单选中key
      console.log("key1: " + selectedKeys1.value[0])
      // 2级菜单选中key
      console.log("key2: " + activeTabKey2.value)
      // 拉取文章列表
      queryArticlesList({})
    }


    onMounted(() => {
      console.log('onMounted ...')

      // 所有分类目录
      queryCategory();

      // 推荐文章
      queryRecommendArticle()

      // 轮播图
      queryRecommendBanners()

      // Top10文章
      queryHotArticle()

    })
    return {
      recommendArticles,
      banners,
      hotArticles,

      currentPage,
      currentSize,
      total,
      onPageChange,
      onShowSizeChange,

      openKeys1,
      selectedKeys1,
      level1,
      items1,
      handleClick1,
      handleTabClick2,

      items2,
      activeTabKey2,
      articleData,
    }


  }
});
</script>

<style scoped>
.container {
  background: #fff;
  /* background: #F5F5F5; */
  padding-top: 65px;
}


/* 第一行距离 */
.gutter-row-1 {
  margin-top: 20px;
}


.gutter-box1 {
  /* background: #0092ff; */
  /* padding: 8px 0; */
  height: 300px;
}

.gutter-box2 {
  /* background: #0091ff41; */
  /* padding: 8px 0; */
  height: 300px;
}

.gutter-box3 {
  /* background: #00ffbf; */
  /* padding: 8px 0; */
  height: 300px;
}

/* 第二行距离 */
.gutter-row-2 {
  margin-top: 40px;
}

.gutter-box4 {
  /* background: #0091ff41; */
  /* margin-top: 50px; */
  /* padding: 8px 0; */
}

.gutter-box5 {
  /* background: #6aff00; */
  /* padding: 8px 0; */
}

.gutter-box6 {
  /* background: #0091ff41; */
  /* padding: 8px 0; */
}

/* 走马灯样式 */
:deep(.slick-slide) {
  text-align: center;
  height: 300px;
  line-height: 300px;
  /* background: #364d79; */
  overflow: hidden;
}

:deep(.slick-slide h3) {
  color: #fff;
}

/* 只显示 1 行字数 */
.display-line1 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  /* cursor: pointer; */
  color: #303133;
}


/* --------------------媒体查询,宽屏拉伸时保持居中显示--------------------------- */
/* 基础样式 */
.center-container {
  width: 100%;
}

/* 基础样式 */
.center-div {
  width: 100%;
}

/* 屏幕宽度大于或等于1475px时应用的样式 */
@media screen and (min-width: 1475px) {

  .center-container {
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    /* 父容器的高度设置为视窗高度 */
    /* 加上header高度 */
    height: 100vh + 70px;
  }

  .center-div {
    /* 或者具体的宽度值 */
    width: 1424px;
  }

}
</style>
